import { useEffect, useState } from "react";
import styles from "./StepProgress.module.css";

/**
 * Dokle je stigao višekoračni posao i koliko tekući korak već traje.
 *
 * Prvi pokušaj su bile tačkice koje se smenjuju (`.`, `..`, `...`). Ideja je
 * bila dobra — dug korak se bez ikakvog pomeranja ne razlikuje od zaglavljenog
 * — ali izvedba nije: natpis je centriran, pa je svaka dodata tačkica pomerala
 * CEO red ulevo. Vrpoljenje umesto obaveštenja.
 *
 * Ovde umesto toga stoji koliko korak traje. Time se dobija i ono što tačkice
 * nikad nisu mogle: ne samo da posao teče, nego i da li je 3 sekunde ili 50.
 * Red je poravnat ulevo a brojač ima svoje mesto sa desna, pa se ništa ne
 * pomera dok se broj menja.
 *
 * @param {{progress: {phase: string, composition: string, index: number, total: number, passes: number}|null}} props
 */
const StepProgress = ({ progress }) => {
    const [seconds, setSeconds] = useState(0);

    // Merenje kreće iznova sa svakim korakom, ne od početka celog posla —
    // pitanje na koje se odgovara je „koliko OVO traje".
    const step = progress ? `${progress.phase}:${progress.composition}:${progress.index}` : null;
    useEffect(() => {
        if (!step) return;
        setSeconds(0);
        const id = setInterval(() => setSeconds((s) => s + 1), 1000);
        return () => clearInterval(id);
    }, [step]);

    if (!progress) return null;

    const { phase, composition, index, total, passes } = progress;
    const counter = total ? `(${Math.min(index + 1, total)}/${total})` : "";

    const label = {
        clearing: `Emptying ${composition} ${counter}, pass ${passes + 1}`,
        dropping: `Removing ${composition} ${counter}`,
        destroying: "Taking the contract off the account",
        unlinking: "Removing it from your list",
    }[phase];

    if (!label) return null;

    return (
        <div className={styles.line}>
            <span className={styles.text}>{label}</span>
            <span className={styles.elapsed}>{seconds}s</span>
        </div>
    );
};

export default StepProgress;
